// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = exports.withTimeout = void 0;
function withTimeout(ms, promise) {
    const timeout = new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Timeout")), ms);
    });
    return Promise.race([promise, timeout]);
}
exports.withTimeout = withTimeout;
function* range(n, from = 0) {
    for (let i = 0; i < n; i++)
        yield from + i;
}
exports.range = range;
//# sourceMappingURL=helpers.js.map